<div class="more_infor_fabric_cont">
	<div class="image_and_text_container">
		<div class="image_cont">
			<img src="{{image}}">
		</div>
		<div class="text_cont">
			<div class="text_cont_text">
				{{name}}
			</div>
			<div class="text_cont_price">
				{{selectedCurrency | uppercase}}
				 {{+(price) |  currencyConverter | number: '1.0-2'}}  / {{unit?unit:'UNIT'}}
			</div>
		</div>
	</div>
	<div class="overView_cont">
		<h3>
			Overview
		</h3>
		<p [innerHTML]="overview|safeHtml">
			<!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus sint tempora eaque, doloribus iusto natus voluptas fugit quibusdam fuga nostrum in quas veritatis maiores sed magni earum assumenda nobis libero. -->
		</p>
	</div>
</div>
